import { Field, useFormikContext } from "formik";
import React, { FC } from 'react';
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import CustomSettingIcon from '../../images/Custom Setting.svg';
import InheritPresetIcon from '../../images/Inherited from Preset.svg';
import ReportImage from '../../images/Reports.svg';
import EntityHierarchy from "../entityHierarchy/entityHierarchy";
import Label from "../label/label";
import { MusteringReportTotals } from "../../models/MusteringReportTotals";
import { getFormattedDate } from "../../services/utilities/dateFormatting";

type ReportProps = {
    isGeneralMusteringReport?: boolean;
    dataTotals?: MusteringReportTotals
}

const ReportEditCard: FC<ReportProps> = ({isGeneralMusteringReport = false, dataTotals}) => {
    const { values } = useFormikContext<any>();
    const { translate } = useLocale();

    return (
        <div className="w-full p-2 flex bg-white">
            <div className="flex items-center ml-8 mr-5 mt-4">
                <img className="h-12" src={ReportImage} alt="report" />
            </div>
            <div className="flex flex-col ml-5 mt-4">
                <div className="flex">
                    <EntityHierarchy title={values.name} labelOnly={true} />
                    <img className="h-6 mt-1" src={values.isTemplate ? InheritPresetIcon : CustomSettingIcon} alt="status" />
                </div>
                <div className="flex flex-row text-sm text-gray-700 -mt-2" id="typeLabel" >
                    <p>{values.type}</p>
                </div>
                <div className="flex flex-row text-sm text-gray-700" id="createdByLabel">
                    <Label htmlFor="createdBy">
                        {translate.byKey(TranslationKeys.author)}:
                    </Label>
                    <p className="ml-1" >{values.createdBy}</p>
                </div>
                {values.lastExecutedTime &&
                    <div className="flex flex-row text-sm text-gray-700" id="lastRunLabel">
                        <Label htmlFor="createdBy">
                            {translate.byKey(TranslationKeys.lastRun)}:
                        </Label>
                        <p className="ml-1" >{`${getFormattedDate(values.lastExecutedTime.replaceAll('-','').substring(0,8))} at ${values.lastExecutedTime.split("T")[1].substring(0,5)}`} </p>
                    </div>
                }
            </div>

            {isGeneralMusteringReport && 
                <div className="m-auto w-1/2">
                    <div className="flex flex-row justify-around">
                        <div className="flex text-sm text-gray-700" style={{width: "30%"}}>
                            <Label htmlFor="totalPersonnelOnSite">
                                {translate.byKey(TranslationKeys.totalPersonnelOnSite)}:
                            </Label>
                            <Field
                                type="number"
                                name="totalPersonnelOnSite"
                                id="totalPersonnelOnSiteId"
                                value={dataTotals?.totalOnSite}
                                className="flex flex-row text-center w-1/2 bg-gray-input"
                                disabled
                            />
                        </div>
                        <div className="flex text-sm text-gray-700" style={{width: "30%"}}>
                            <Label htmlFor="totalPersonnelMustered">
                                {translate.byKey(TranslationKeys.totalPersonnelMustered)}:
                            </Label>
                            <Field
                                type="number"
                                name="totalPersonnelOnMustered"
                                id="totalPersonnelMusteredId"
                                value={dataTotals?.totalMustered}
                                className="flex flex-row text-center w-1/2 bg-gray-input"
                                disabled
                            />
                        </div>
                        <div className="flex text-sm text-gray-700" style={{width: "30%"}}>
                            <Label htmlFor="totalPersonnelUnaccountedFor">
                                {translate.byKey(TranslationKeys.totalPersonnelUnaccountedFor)}:
                            </Label>
                            <Field
                                type="number"
                                name="totalPersonnelUnaccountedFor"
                                id="totalPersonnelUnaccountedForId"
                                value={(dataTotals?.unaccountedWithExited) ?? 0}
                                className={`flex flex-row text-center w-1/2 ${((dataTotals?.unaccountedWithExited) ?? 0) > 0 ? 'bg-red-300' : 'bg-gray-input'}`}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default ReportEditCard;
